<script setup lang="ts">
const emit = defineEmits(["select", "update:modelValue"]);
const props = defineProps<{
  itemProp: string;
  data?: any[] | null | undefined;
  disabled?: boolean;
  disabledProp?: string;
  emptyText?: string;
  header?: string;
  headerClass?: string | string[];
  isLoading?: boolean;
  itemClass?: string | string[];
  modelValue?: string[] | object[];
  prop: string;
  useRadioButtons?: boolean;
}>();

const selectedItems = computed({
  get() {
    return props.modelValue ?? [];
  },
  /* In the case of radio buttons, the returned value is not an array but a
   * string as only one element can be chosen from the list.
   */
  set(selected?: string[] | string) {
    if (typeof selected === "string") {
      if (selected["uid"] !== undefined) {
        emit("update:modelValue", [selected]);
        emit("select", [selected]);
      } else {
        const models =
          props.data !== null && props.data !== undefined
            ? toRaw(props.data)?.filter((item) => item.value === selected)
            : [];
        emit("update:modelValue", models);
        emit("select", models);
      }
    } else {
      emit("update:modelValue", selected);
      emit("select", selected);
    }
  },
});
</script>
<template>
  <lxc-selectable-list
    v-model="selectedItems"
    :item-prop="itemProp"
    :data="data"
    :empty-text="emptyText"
    :header="header"
    header-class="underline"
    :loading="isLoading"
    :item-class="itemClass"
    :prop="prop"
    :disabled="disabled"
    :disabled-prop="disabledProp"
    :type="useRadioButtons ? 'radio' : 'checkbox'"
  />
</template>
